import { useRef } from 'react';
import timeTracker from '../MainV2/icons/timeTracker.svg';
import TimeTrackerModal, { TimeTrackerModalRef } from '../TimeTrackerModal';
import { verifyPinCode } from 'widgets/RequestAdminLocalPW/Callback';
import PermissionManager from 'widgets/PermissionVerify';
import { FEATURE_KEYS } from 'constants/Permission';

const ButtonTimeTracker = ({ title = 'Time Tracker' }: { title?: string }) => {
  const timeTrackerModalRef = useRef<TimeTrackerModalRef>(null);

  const callback = () => {
    timeTrackerModalRef.current?.open();
  };

  const handleOpen = async () => {
    const result = await PermissionManager.verify(FEATURE_KEYS.HOME_TIME_TRACKER);
    if (result !== null) {
      if (!result || result?.skip) return callback();
      if (!result.verifyData) return;
      return callback();
    } else {
      verifyPinCode(() => callback());
    }
  };

  return (
    <>
      <button className='btn' onClick={handleOpen}>
        <img src={timeTracker} alt='timeTracker' className='icon-action' />
        <span>{title}</span>
      </button>
      <TimeTrackerModal ref={timeTrackerModalRef} />
    </>
  );
};
export default ButtonTimeTracker;
